import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Query, QueryDocumentSnapshot } from '@firebase/firestore-types';

@Injectable({
  providedIn: 'root',
})
export class DbService {
  firestore = this.angularFirestore.firestore;
  createId = this.angularFirestore.createId;
  root = this.angularFirestore;

  constructor(private angularFirestore: AngularFirestore) {}

  async getArrayContainsAnyBatchRequest(query: Query, array: string[] | number[], propertyDb: string): Promise<QueryDocumentSnapshot[]> {
    const copyArray = [...array];
    const indexesQuantity = Math.ceil(copyArray.length / 10);
    const indexes = Array.from({ length: indexesQuantity }, (_, i) => i);
    const promises = indexes.map((_) => {
      const batch = copyArray.splice(0, 10);
      const arrayContainsQuery = query.where(propertyDb, 'array-contains-any', [...batch]);
      return arrayContainsQuery.get();
    });
    const docs = await Promise.all(promises);
    const docsFlat = docs.reduce((acc, el) => acc.concat(el.docs), []);
    const withoutRepeats: QueryDocumentSnapshot[] = docsFlat.reduce(
      (acc, el) => (acc.some((a: QueryDocumentSnapshot) => a.data()?.id == el?.id) ? acc : acc.concat(el)),
      []
    );
    return withoutRepeats;
  }
}
